import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import {
  mapChromaVectorSyncRunResult,
  mapChromaVectorSyncTargetList,
  type ChromaVectorSyncRunResultRaw,
  type ChromaVectorSyncTargetListRaw,
} from "../api/adapters";
import type { ChromaVectorSyncRunResult, ChromaVectorSyncTargetList } from "../types";

const CHROMA_VECTOR_SYNC_OPERATION_TIMEOUT_MS = 300_000;

/** 查询 Chroma 向量库同步对象列表。 */
export async function fetchChromaVectorSyncTargets(): Promise<ChromaVectorSyncTargetList> {
  const response = await httpClient.get<ApiEnvelope<ChromaVectorSyncTargetListRaw>>(
    "/chroma-vector-sync/targets",
  );
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("同步向量库对象接口返回了无效数据");
  }
  return mapChromaVectorSyncTargetList(response.data.data);
}

/** 执行单个 Chroma 向量库全量同步对象。 */
export async function executeChromaVectorSyncTarget(
  targetKey: string,
): Promise<ChromaVectorSyncRunResult> {
  const response = await httpClient.post<ApiEnvelope<ChromaVectorSyncRunResultRaw>>(
    `/chroma-vector-sync/targets/${targetKey}/execute`,
    undefined,
    { timeout: CHROMA_VECTOR_SYNC_OPERATION_TIMEOUT_MS },
  );
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("同步向量库执行接口返回了无效数据");
  }
  return mapChromaVectorSyncRunResult(response.data.data);
}
